// @flow
import withQuery from "hoc/withQuery"
import { listSubscriptionTypes } from "data/subscriptions/graphql/queries"
import { listDiscounts } from "data/discounts/queries"
import { getPlan } from "data/plans/helpers"
import { omit } from "ramda"
import {
  compose,
  withProps,
  mapProps,
  type HOC,
} from "recompose"

type Added = {|
  discountId: number,
|}

const passportPlan = getPlan("Passport")

function withPassport<T>(): HOC<
  // $ExpectError
  { ...$Exact<Added>, ...$Exact<T> },
  T,
> {
  return compose(
    withQuery(listSubscriptionTypes),
    withProps(props => {

      const subscriptionTypeId = Array.isArray(props.data) && passportPlan &&
        props.data.find(subscription => subscription.slug === passportPlan.slug);
        
      if (subscriptionTypeId) return subscriptionTypeId.id;
     
      return {
        subscriptionTypeId: false,
      }
    }),
    withQuery(listDiscounts, {
      variables: props => ({
        filter: {
          subscriptionTypeId: props.subscriptionTypeId,
        },
      }),
      skip: props => !props.subscriptionTypeId,
      noEmpty: true,
    }),
    withProps(props => {
      // Gets the discountId of the 100% discount of awayco_user_passport subscription type
      const discountId = Array.isArray(props.data) &&
        props.data.find(discount => discount.percentage === 100);

      if (discountId) return discountId.id
      
      return {
        discountId: false,
      }
    }),
    mapProps(omit(["data"])),
  )
}

export default withPassport



// WEBPACK FOOTER //
// ./src/hoc/withPassport.js